// CompanyAnnouncements.js
import React, { useState, useEffect } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import PropTypes from "prop-types";

function CompanyAnnouncements({ token }) {
  const navigate = useNavigate();
  const [announcements, setAnnouncements] = useState([]);
  const [loading, setLoading]       = useState(true);
  const [error, setError]           = useState(null);

  useEffect(() => {
    (async () => {
      try {
        const { data } = await axios.get("/announcement", {
          headers: { Authorization: `Bearer ${token}` },
        });
        if (data.success) setAnnouncements(data.announcements);
        else setError(data.message || "Failed to load announcements");
      } catch {
        setError("Failed to fetch announcements");
      } finally {
        setLoading(false);
      }
    })();
  }, [token]);

  const handleEdit = (id) => {
    navigate(`/announcement?announcementId=${id}`);
  };

  const addLinksToMessage = (message) => {
    if(typeof message !== "string")
      return message;
    return message.replace(
      /</g,
      "&lt;"
    ).replace(
      />/g,
      "&gt;"
    ).replace(
      /\{([^|]*?)\}/g,
      "<a href='$1' style='color: maroon' target='_blank'>$1</a>"
    ).replace(
      /{(.*?)\|(.*?)}/g,
      "<a href='$2' style='color: maroon' target='_blank'>$1</a>"
    );
  };

  const handleBackHome         = () => navigate("/");
  const handleBackToAnnouncements = () => navigate("/announcement");

  if (loading) {
    return (
      <div className="Homepage flex items-center justify-center min-h-screen">
        <div>Loading...</div>
      </div>
    );
  }
  if (error) {
    return (
      <div className="Homepage flex items-center justify-center min-h-screen">
        <div>Error: {error}</div>
      </div>
    );
  }

  return (
    <div className="Homepage flex flex-col min-h-screen">
      <div className="flex-grow w-full max-w-6xl mx-auto py-1 px-4">
        <div className="bg-white rounded-2xl shadow-md p-6 mb-6">
          <h1 className="text-2xl font-bold mb-4">Previous Announcements:</h1>
        </div>
        <div className="bg-white rounded-2xl shadow-md p-6 max-w-6xl w-full mx-auto">
          {announcements.length === 0 ? (
            <p>No announcements found.</p>
          ) : (
            <ul className="space-y-4 max-h-[70vh] overflow-y-auto">
              {announcements.map((a) => (
                <li key={a.announcementId} className="border p-4 rounded">
                  <h3 className="font-bold">{a.subject}</h3>
                  <p className="whitespace-normal break-words" dangerouslySetInnerHTML={{ __html: addLinksToMessage(a.message) }}></p>
                  <p className="text-sm text-gray-600">Start Date: {a.startDate}</p>
                  <p className="text-sm text-gray-600">End Date: {a.expireDate}</p>
                  <p className="text-sm text-gray-600">Status: {a.status}</p>
                  <button
                    onClick={() => handleEdit(a.announcementId)}
                    className="mt-3 bg-gray-300 text-black rounded-full px-4 py-2 shadow-lg hover:bg-gray-400"
                  >
                    Edit Announcement
                  </button>
                </li>
              ))}
            </ul>
          )}
        </div>
        <div className="flex justify-center gap-4 mt-6">
          <button
            onClick={handleBackHome}
            className="bg-gray-300 text-black rounded-full px-6 py-3 shadow-lg hover:bg-gray-400"
          >
            Return to Home
          </button>
          <button
            onClick={handleBackToAnnouncements}
            className="bg-gray-300 text-black rounded-full px-6 py-3 shadow-lg hover:bg-gray-400"
          >
            Back to Announcements
          </button>
        </div>
      </div>
    </div>
  );
}

CompanyAnnouncements.propTypes = {
  token: PropTypes.string.isRequired,
};

export default CompanyAnnouncements;
